export const API_KEY = `AIzaSyDg7hK7H5hCSp39zFQge8xtdviEtSZ52Jk`;
